import { render } from "./Tag.vue?vue&type=template&id=0c7d62b4"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Tags/Tag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c7d62b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c7d62b4', __exports__)) {
    api.reload('0c7d62b4', __exports__)
  }
  
  module.hot.accept("./Tag.vue?vue&type=template&id=0c7d62b4", () => {
    api.rerender('0c7d62b4', render)
  })

}


export default __exports__